export const config = {
  lnt_api_url: 'https://api-smartcleaning.thingsee.io/v1',
  db_url: 'api-smartcleaning.thingsee.io/hasura/v1/graphql',
  // lnt_api_url: 'http://localhost:5050/v1',
  // db_url: 'localhost:9090/v1/graphql',
};
